/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantPublicProcessSettingsExamAttemptsPerModule } from './tenantPublicProcessSettingsExamAttemptsPerModule';

/**
 * Public process settings for tenants
 */
export interface TenantPublicProcessSettings {
  legacyCourseCompatibilityMode?: boolean;
  examAttemptsPerModule?: TenantPublicProcessSettingsExamAttemptsPerModule;
}
